import { type ReactNode } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import classNames from 'classnames'
import './ContactLinking.scss'

interface ColumnHeading {
  icon: ReactNode
  label: string
}

interface ContactLinkingSectionProps {
  description: ReactNode
  sourceHeading: ColumnHeading
  targetHeading: ColumnHeading
  hasDeletableRows?: boolean
  error?: string
  footer?: ReactNode
  children: ReactNode
}

const ColumnHeadingLabel: React.FC<ColumnHeading> = ({ icon, label }) => (
  <>
    {icon}
    <span className='ms-2'>{label}</span>
  </>
)

export const ContactLinkingSection: React.FC<ContactLinkingSectionProps> = ({
  description,
  sourceHeading,
  targetHeading,
  hasDeletableRows = false,
  error,
  footer,
  children,
}) => (
  <Container className='p-0'>
    <Row className='mb-3'>
      <Col>
        <h4>Contact Linking</h4>
        <p className='zocks-text-gray-600'>{description}</p>
      </Col>
    </Row>
    <div className={classNames('contact-link-grid column-gap-2', { 'contact-link-grid--with-delete': hasDeletableRows })}>
      <div className='contact-link-grid__row mb-2 fw-bold'>
        <div className='d-flex align-items-center'>
          <ColumnHeadingLabel {...sourceHeading} />
        </div>
        <div className='contact-link-grid__target d-flex align-items-center'>
          <ColumnHeadingLabel {...targetHeading} />
        </div>
      </div>
      {children}
    </div>
    {error ? <div className='invalid-feedback d-block'>{error}</div> : null}
    {footer}
  </Container>
)
